import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=3b8b9174&scoped=true&"
import script from "./InfiniteScroll.vue?vue&type=script&lang=js&"
export * from "./InfiniteScroll.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteScroll.vue?vue&type=style&index=0&id=3b8b9174&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b9174",
  null
  
)

export default component.exports